import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';
import { Alert as MuiAlert, AlertTitle, AlertProps } from '@material-ui/lab';

interface Props {
  title?: string;
}

const useAlertStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&.MuiAlert-standardWarning': {
        borderTop: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.common.white,
      },
      '&.MuiAlert-standardWarning:first-child': {
        borderTop: `3px solid ${theme.palette.primary.main}`,
      },
      '& .MuiAlert-icon': {
        color: theme.palette.primary.main,
      },
      '& .MuiAlert-message': {
        padding: 0,
        display: 'flex',
        alignItems: 'center',
      },
      '& .MuiAlertTitle-root': {
        marginTop: 7,
      },
    },
  }),
);

const Alert: React.FC<Props & AlertProps> = ({ children, title, ...alertProps }) => {
  const classes = useAlertStyles();
  return (
    <MuiAlert severity="warning" {...alertProps} className={classes.root}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </MuiAlert>
  );
};

export default Alert;
